import {
  backgroundBlurAbortError,
  SoftwareBackgroundBlurError,
} from './background-blur-error';

/** Bound browser operations that cannot themselves be cancelled. Late results
 * are consumed, but cannot resume an aborted caller. */
export function waitForOperation<T>(
  operation: Promise<T>,
  signal: AbortSignal,
  timeoutMs: number,
  timeoutMessage: string,
): Promise<T> {
  return new Promise((resolve, reject) => {
    const cleanup = () => {
      clearTimeout(timer);
      signal.removeEventListener('abort', onAbort);
    };
    const onAbort = () => {
      cleanup();
      reject(signal.reason ?? backgroundBlurAbortError());
    };
    const timer = setTimeout(() => {
      cleanup();
      reject(new SoftwareBackgroundBlurError(timeoutMessage));
    }, timeoutMs);
    signal.addEventListener('abort', onAbort, { once: true });
    operation.then(
      (result) => {
        cleanup();
        if (signal.aborted) reject(signal.reason ?? backgroundBlurAbortError());
        else resolve(result);
      },
      (error) => {
        cleanup();
        reject(
          signal.aborted
            ? (signal.reason ?? backgroundBlurAbortError())
            : error,
        );
      },
    );
    if (signal.aborted) onAbort();
  });
}
